import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const WebRiskMonitoring: React.FC = () => {
  const sections = [
    {
      title: 'Comprehensive Web Risk Monitoring',
      content: 'Our web risk monitoring services provide continuous surveillance of your organization\'s digital footprint, identifying potential threats, vulnerabilities, and compliance risks across your web presence. We monitor websites, web applications, and digital assets to ensure they meet security standards and regulatory requirements.',
      benefits: [
        'Continuous website and web application monitoring',
        'SSL/TLS certificate management and monitoring',
        'Domain and subdomain security assessment',
        'Web application vulnerability scanning',
        'Content security policy monitoring'
      ]
    },
    {
      title: 'Threat Intelligence and Detection',
      content: 'Our advanced threat intelligence capabilities help identify emerging risks and potential attacks targeting your web assets before they impact your business.',
      benefits: [
        'Real-time threat detection and alerting',
        'Dark web monitoring for compromised data',
        'Phishing and brand impersonation detection',
        'Malware and malicious content identification',
        'Suspicious domain registration monitoring'
      ]
    },
    {
      title: 'Compliance and Risk Assessment',
      content: 'We help ensure your web presence meets industry standards and regulatory requirements while identifying and mitigating potential compliance risks.',
      benefits: [
        'GDPR and privacy regulation compliance monitoring',
        'Accessibility standards (WCAG) assessment',
        'Industry-specific compliance validation',
        'Third-party integration risk assessment',
        'Data protection and privacy monitoring'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Monitoring Frequency',
      content: 'Continuous 24/7 monitoring with real-time alerts for critical security events and compliance violations.'
    },
    {
      title: 'Coverage Scope',
      content: 'Monitor all web assets including main websites, subdomains, web applications, APIs, and third-party integrations.'
    },
    {
      title: 'Reporting',
      content: 'Comprehensive weekly, monthly, and quarterly reports with executive summaries and detailed technical findings.'
    }
  ];

  return (
    <ServiceTemplate
      title="Web Risk Monitoring"
      subtitle="Continuous monitoring and assessment of your web presence to identify security vulnerabilities, compliance risks, and emerging threats."
      sections={sections}
      ctaTitle="Secure Your Web Presence"
      ctaDescription="Protect your digital assets with comprehensive web risk monitoring and real-time threat detection services."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default WebRiskMonitoring;

